module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("HOME")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_MERCHANT') ||
    _vm.hasPermission('CAN_APPROVE_MERCHANT') ||
    _vm.hasPermission('CAN_VIEW_MERCHANT')
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n    Merchants\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_MERCHANT')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/create"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Create Merchant")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_MERCHANT')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/approve"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Approve Merchants")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_MERCHANT')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/view"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("View Merchants")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_MERCHANT') || _vm.hasPermission('CAN_APPROVE_MERCHANT')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/requests"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Merchant Creation Requests")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_BULK') || _vm.hasPermission('CAN_UPLOAD_BULK')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/bulk_upload"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Bulk Uploads")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_BULK')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/bulk_upload_approve"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Bulk Uploads Approval")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_STORE')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n    Stores\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_STORE')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/stores/approve"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Approve Store")])])]) : _vm._e(), _vm._v(" "), (_vm.hasStores()) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n    Transactions\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasStores()) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/pos_statement_today"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Today's Card Transactions")])])]) : _vm._e(), _vm._v(" "), (_vm.hasStores()) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/pos_statement"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Settled Card Transactions")])])]) : _vm._e(), _vm._v(" "), (_vm.hasStores()) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/mpesa_transaction"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Mpesa Transactions")])])]) : _vm._e(), _vm._v(" "), (_vm.hasStores()) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/stkpush_transaction"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("STK Push Transactions")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_INTERNALUSERS') ||
    _vm.hasPermission('CAN_VIEW_INTERNALUSERS') ||
    _vm.hasPermission('CAN_APPROVE_INTERNALUSERS')
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n   Users\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_INTERNALUSERS') ||
    _vm.hasPermission('CAN_VIEW_INTERNALUSERS') ||
    _vm.hasPermission('CAN_APPROVE_INTERNALUSERS') || _vm.hasPermission('CAN_APPROVE_EXTERNALUSERS')
  ) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_CREATE_INTERNALUSERS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/user/internal/create"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Create User")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_INTERNALUSERS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/user/internal/view"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("View Users")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_INTERNALUSERS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/user/internal/approve"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Approve Users")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_EXTERNALUSERS')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_APPROVE_EXTERNALUSERS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/merchant/users/approve"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Approve External Users")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_INTERNALUSERS') ||
    _vm.hasPermission('CAN_APPROVE_INTERNALUSERS') ||
    _vm.hasPermission('CAN_CREATE_EXTERNALUSERS') ||
    _vm.hasPermission('CAN_APPROVE_EXTERNALUSERS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/user/requests"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User Creation Requests")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_ROLE') ||
    _vm.hasPermission('CAN_VIEW_ROLE')
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n    Roles\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_ROLE') ||
    _vm.hasPermission('CAN_VIEW_ROLE') ||
    _vm.hasPermission('CAN_APPROVE_ROLE')
  ) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_CREATE_ROLE')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/createrole"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Create Role")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_ROLE')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/viewroles"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("View Roles")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_APPROVE_ROLE')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/approverole"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Approve Roles")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_PERMISSION') ||
    _vm.hasPermission('CAN_VIEW_PERMISSION')
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n    Permissions\n  ")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_CREATE_PERMISSION') ||
    _vm.hasPermission('CAN_VIEW_PERMISSION')
  ) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_CREATE_PERMISSION')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/permission/create"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Create Permission")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_PERMISSION')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/permission/view"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("View Permissions")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_SYSTEMSTATUS')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_VIEW_SYSTEMSTATUS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/systemstatus"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Database")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPermission('CAN_VIEW_NOTIFICATIONS')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(_vm.hasPermission('CAN_VIEW_NOTIFICATIONS')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/tokennotification"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User Reg Tokens")])])]) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Internal Users")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("External Users")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Roles")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Permissions")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("System Status")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac58a96e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1069
// module chunks = 2